module.exports = __webpack_public_path__ + "img/map.fcc37b58.jpg";